// Words that we blacklist so any Speech to Text won't display them on the screen
export const blacklistedWords: string[] = [
  "fuck",
  "shit",
  "bitch",
  "piss",
  "cunt",
];
